import React from "react";
import { Color } from "config/colors";
import { ActionsCell } from "../tips.styled";
import { useTranslation } from "react-i18next";
import { TipDetails, TipStatus } from "model/Tip";
import { CircularProgress } from "@material-ui/core";
import { CustomIcon } from "components/icon/customIcon.component";
import { IconCircularContainer } from "../../../dashboard/dashboard.styled";

type ActionsCellProps = {
  tip: TipDetails;
  isMultiSelectActive: boolean;
  isExpanded: boolean;
  isSelected: boolean;
  isDeleting: boolean;
  onToggleDropdown: () => void;
  onToggleSelect: () => void;
  onDelete: () => void;
};

export const TipActionsCell: React.FC<ActionsCellProps> = (props) => {
  const { t } = useTranslation();

  const shouldShowCheckmark = (): boolean => {
    return (
      props.tip.status === TipStatus.Saved ||
      props.tip.status === TipStatus.Done ||
      props.tip.status === TipStatus.Created
    );
  };

  const checkmarkIsDisabled = (): boolean => {
    return props.tip.approvedCount <= 0 || props.tip.amount <= 0;
  };

  const isClosedTip = (): boolean => {
    return (
      props.tip.status === TipStatus.Closed || props.tip.status === TipStatus.ClosedManually
    );
  };

  return (
    <ActionsCell isMultiSelectActive={props.isMultiSelectActive}>
      <CustomIcon
        name="person"
        title={
          props.tip.approvedCount > 0
            ? t("CompanyTip.HasApprovedReports")
            : t("CompanyTip.NoApprovedReports")
        }
        size="22px"
        color={props.tip.approvedCount > 0 ? Color.LighterPositive : Color.Disabled}
      />

      <CustomIcon
        name="chevron-down"
        size="20px"
        title={props.isExpanded ? t("CompanyTip.Close") : t("CompanyTip.ShowDetails")}
        color={Color.MidnightBlue}
        onClick={props.onToggleDropdown}
        style={{
          transition: "transform 0.2s",
          transform: props.isExpanded ? "rotate(180deg)" : "rotate(0deg)",
        }}
      />

      {props.isMultiSelectActive && shouldShowCheckmark() ? (
        <CustomIcon
          name="checkmark"
          title= { checkmarkIsDisabled() ? t("CompanyTip.NoTimereportsOrAmount") : t("CompanyTip.Select")}
          size="27px"
          color={Color.White}
          backgroundColor={props.isSelected ? Color.MidnightBlue : Color.White}
          padding="2px"
          onClick={!checkmarkIsDisabled() ? props.onToggleSelect : undefined}
          style={{
            border: `2px solid ${Color.MidnightBlue}`,
            opacity: checkmarkIsDisabled() ? 0.4 : 1,
          }}
        />
      ) : (
        <div style={{ width: "27px", height: "27px" }} />
      )}

      {!isClosedTip() ? (
        <IconCircularContainer
          onClick={props.onDelete}
          style={{
            opacity: props.isDeleting ? 0.5 : 1,
            pointerEvents: props.isDeleting ? "none" : "auto",
          }}
        >
          {props.isDeleting ? (
            <CircularProgress size={20} style={{ color: Color.White }} />
          ) : (
            <CustomIcon
              name="trashcan"
              size="20px"
              padding="2px"
              color={Color.White}
              title={t("CompanyTip.Remove")}
            />
          )}
        </IconCircularContainer>
      ) : (
        <div style={{ width: "27px", height: "27px" }} />
      )}
    </ActionsCell>
  );
};
